
import Header from '../../components/feature/Header';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import SearchSection from './components/SearchSection';
import ServicesSection from './components/ServicesSection';
import WhyChooseUsSection from './components/WhyChooseUsSection';
import FeaturedPropertiesSection from './components/FeaturedPropertiesSection';
import TestimonialsSection from './components/TestimonialsSection';
import AreaInfoSection from './components/AreaInfoSection';
import CTASection from './components/CTASection';

export default function Home() {
  return (
    <div className="min-h-screen">
      <Header />
      <main>
        <HeroSection />
        <SearchSection />
        <ServicesSection />
        <WhyChooseUsSection />
        <FeaturedPropertiesSection />
        <TestimonialsSection />
        <AreaInfoSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
}
